<template>
    <div>
        <div>
            <el-button type="primary" v-on:click="showModal = true">Ingresar Factura, NC o ND</el-button>
        </div>
        <el-dialog title="Cargar Factura, NC o ND" :visible.sync="showModal" :append-to-body="true" class="mobile " width="90%">
            <el-divider></el-divider>
            <el-form :label-position="currentLabelPosition" ref="formRef" :rules="formRules" :model="document" label-width="160px" class="form-container">
                <el-divider v-if="hesMigo.length !== 0" content-position="left" class="labelName">Código de Documentación</el-divider>
                <el-form-item v-if="hesMigo.length !== 0" size="small" label="Código de Documentación" class="form-select">
                    <el-select v-model="document.code" class="form-select-list" placeholder="Código de Documentación" @change="updateDescriptionTipo">
                    <el-option
                        v-for="item in hesMigo"
                        :key="item.idHes"
                        :label="item.number"
                        :value="item.idHes">
                    </el-option>
                </el-select>
                </el-form-item>
                <div v-if="hesMigo.length !== 0">
                    <el-form-item label="Descripción" class="form-input" size="small">
                        <el-input disabled v-model="document.description"></el-input>
                    </el-form-item>
                    <el-form-item label="Tipo de código" class="form-input" size="small">
                        <el-input disabled v-model="document.tipo"></el-input>
                    </el-form-item>
                </div>
                <el-divider content-position="left">Datos de la operacion</el-divider>
                <!-- <el-divider content-position="left">Datos del Documento</el-divider> -->
                <el-form-item size="small" label="Tipo de operación" class="form-select" prop="documenttype">
                    <el-select v-model="document.documenttype" placeholder="Tipo de operación">
                    <el-option
                        v-for="item in documentType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                </el-form-item>
                <el-form-item label="Código de AFIP" class="form-input" size="small" prop="codigoAFIP">
                    <el-input v-model="document.codigoAFIP"></el-input>
                </el-form-item>
                <el-form-item label="Letra" class="form-input" size="small" prop="letra">
                    <el-input v-model="document.letra"></el-input>
                </el-form-item>
                <el-form-item label="Numero" class="form-input" size="small" prop="numero">
                    <el-input v-model="document.numero"></el-input>
                </el-form-item>
                <el-divider content-position="left">Datos CAE</el-divider>
                <el-form-item label="Fecha de Vencimiento" class="form-input" size="small" prop="fechaVencimiento">
                    <el-date-picker
                        class="form-date"
                        v-model="document.fechaVencimiento"
                        type="date"
                        placeholder="Selecciona fecha de Vencimiento"
                        :default-value="new Date()"
                    />
                </el-form-item>
                <el-form-item label="Nº" class="form-input" size="small" prop="NroCAE">
                    <el-input v-model="document.NroCAE"></el-input>
                </el-form-item>
                <el-form-item size="small" label="PDF" class="form-upload" prop="pdfDoc">
                    <pdf-file
                    v-bind:pdfFilePath.sync="document.pdfDoc"
                    :habModificaPdf="habModificaPdf"
                    id="documento"
                    prop="documento"
                    class="form-pdf"
                  />
                </el-form-item>
                <el-divider v-if="loadOperationType === true" content-position="left">Datos de Referencia</el-divider>
                <el-form-item v-if="loadOperationType === true" size="small" label="Tipo de transacción" class="form-select">
                    <el-select v-model="document.ocType" placeholder="Tipo de transacción">
                    <el-option
                        v-for="item in acceptanceType"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                </el-form-item>
                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" :key="index">
                    <el-row>
                        <el-col :span="24">
                            <p class="input-text">Número de operación</p>
                        </el-col>
                        <el-col :span="12" class="input-view1">
                            <el-input v-model="document.ocNumber" placeholder="Numero de HES"></el-input>
                        </el-col>
                        <el-col :span="12" class="input-view2">
                            <el-button style="margin-left: 35px;" type="warning" @click="addOcNumber">+</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item size="small" class="form-input" v-if="document.ocType === '1'" v-for="(ocNumber, index) in document.ocNumbers" :key="index">
                    <el-row>
                        <el-col :span="12" class="input-view1">
                            <el-input v-model="ocNumber.value" placeholder="Numero de HES"></el-input>
                        </el-col>
                        <el-col :span="12" class="input-view2">
                            <el-button style="margin-left: 35px;" type="warning" @click="deleteOcNumber(index)">-</el-button>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-form-item size="small" class="form-input" v-if="document.ocType === '2'">
                    <el-row>
                        <el-col :span="24">
                            <p class="input-text">Número de operación</p>
                        </el-col>
                        <el-col :span="12" class="input-view1">
                            <el-input placeholder="Numero de MIGO" v-model="document.migoNumber"></el-input>
                        </el-col>
                    </el-row>
                </el-form-item>
                <el-divider content-position="left">Importes</el-divider>
                <el-form-item label="Importe Total" class="form-input" size="small" prop="importeTotal">
                    <el-input v-model="document.importeTotal"></el-input>
                </el-form-item>
                <el-form-item label="Importe Impuesto" class="form-input" size="small" prop="importeImpuesto">
                    <el-input v-model="document.importeImpuesto"></el-input>
                </el-form-item>
                <el-form-item label="Porcentaje Impuesto" class="form-input" size="small" prop="porcentajeImpuesto">
                    <el-input v-model="document.porcentajeImpuesto"></el-input>
                </el-form-item>
                <el-form-item label="Moneda" class="form-input" size="small" prop="moneda">
                    <el-input v-model="document.moneda"></el-input>
                </el-form-item>
                <el-form-item label="Tipo de Cambio" class="form-input" size="small" prop="tipoDeCambio">
                    <el-input v-model="document.tipoDeCambio"></el-input>
                </el-form-item>
            </el-form>
            <el-divider></el-divider>
            <el-button v-on:click="validateForm" class="btn" type="primary">
                Guardar
            </el-button>
            <el-button class="btn" type="info" v-on:click="showModal = false">
                Cancelar
            </el-button>
        </el-dialog>
    </div>
  </template>
  
  <script>
  // import api from '../../api'
  import PdfFile from '../PdfFile.vue'
  import UploadOrder from './UploadOrder.vue'
  import api from '../../api'
  
  export default {
    name: 'ButtonGroup',
    components: {
      'pdf-file': PdfFile,
      'upload-order': UploadOrder
    },
    props: {
      loadOperationType: {
        type: Boolean
      },
      idBuyOrder: {
        type: String
      },
      idCompany: {
        type: String
      }
    },
    data () {
      return {
        showModal: false,
        document: {
          documenttype: '',
          ocType: '',
          ocNumbers: [],
          pdfDoc: '',
          migoNumber: '',
          codigoAFIP: '',
          letra: '',
          numero: '',
          fechaVencimiento: '',
          NroCAE: '',
          importeTotal: '',
          importeImpuesto: '',
          porcentajeImpuesto: '',
          moneda: '',
          tipoDeCambio: '',
          idBuyOrder: this.idBuyOrder,
          code: '',
          description: '',
          tipo: '',
          idCompany: this.idCompany,
          labelPosition: 'left'
        },
        formRules: {
          operationCode: [
            { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          documenttype: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          codigoAFIP: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }
          ],
          letra: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }
          ],
          numero: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }
          ],
          proveedor: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          fechaVencimiento: [
              { type: 'date', required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          NroCAE: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+$/, message: 'Solo se permiten números en este campo', trigger: 'change' }
          ],
          pdfDoc: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' }
          ],
          importeTotal: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ],
          importeImpuesto: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ],
          porcentajeImpuesto: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ],
          moneda: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[A-Za-z]+$/, message: 'Solo se permiten letras en este campo', trigger: 'change' }
          ],
          tipoDeCambio: [
              { required: true, message: 'Este campo es obligatorio', trigger: 'change' },
              { pattern: /^[0-9]+(\.[0-9]+)?$/, message: 'Solo se permiten números decimales en este campo', trigger: 'change' }
          ]
        },
        hesMigo: [],
        documentType: [{value: '1', label: 'Factura'}, {value: '2', label: 'Nota de crédito'}, {value: '3', label: 'Nota de débito'}],
        acceptanceType: [{value: '1', label: 'HES'}, {value: '2', label: 'MIGO'}],
        habModificaPdf: true
      }
    },
    computed: {
      currentLabelPosition () {
        const screenWidth = window.innerWidth
        return screenWidth < 900 ? 'top' : this.labelPosition
      }
    },
    methods: {
      addOcNumber () {
        this.document.ocNumbers.push({ value: '' })
      },
      getHesMigoData () {
        api.request('GET', `api/getHesMigoData?buyOrder=${this.idBuyOrder}`)
        .then(response => {
          var data = response.data
          if (data.error) {
            return
          }
          if (data) {
            this.hesMigo = data.data
            console.log(this.hesMigo)
          }
        })
        .catch(error => {
          this.$store.commit('TOGGLE_LOADING')
          console.log(error)
        })
      },
      deleteOcNumber (index) {
        this.document.ocNumbers.splice(index, 1)
      },
      createDocumentWithOc () {
        if (this.hesMigo.length === 0) {
          this.$message.error('No hay codigos disponibles para cargar una factura')
          return
        }
        if (this.document.code === '') {
          this.$message.error('Falta seleccionar el codigo de operacion')
          return
        }
        api.request('POST', 'api/createDocumentWithOc', JSON.stringify(this.document))
          .then((response) => {
            this.$message({
              message: 'Documento creado correctamente',
              type: 'success',
              duration: 5000
            })
            this.$router.push('/')
          })
          .catch((error) => {
            console.log(error)
          })
      },
      updateDescriptionTipo () {
        const selectedCode = this.document.code
        const selectedHes = this.hesMigo.find(item => item.idHes === selectedCode)
        if (selectedHes) {
          this.document.description = selectedHes.description
          this.document.tipo = selectedHes.type
        } else {
          this.document.description = ''
          this.document.tipo = ''
        }
      },
      validateForm () {
        this.$refs.formRef.validate((valid) => {
          if (valid) {
            this.createDocumentWithOc()
          } else {
            this.$message.error('Debe completar todos los campos')
          }
        })
      }
    },
    beforeMount () {
      this.getHesMigoData()
    },
    mounted () {
      window.addEventListener('resize', () => {
        this.currentLabelPosition = window.innerWidth < 900 ? 'top' : this.labelPosition
      })
    }
  }
  </script>
  <style scoped>
  @media screen and (max-width: 992px) {
    .labelName{
      display: none;
    }
    .form-input {
        margin-left: 0px !important;
        text-align: left !important;
    }
  }
    .el-form-item__label-wrap{
      margin-left: 0px !important;
    }
    .form-container {
        margin-top: 30px;
        margin-left: 50px;
    }
    .form-text {
        font-size: 14px;
    }
    .form-date{
        width: 40% !important;
    }
    .form-input{
        margin-left: -45px;
        width: 60%;
    }
    .form-input input {
        margin-left: 20px;
    }
    .form-select{
        width: 30%;
        margin-left: -25px;
    }
    .form-upload{
        margin-left:-35px;
    }
    .form-pdf{
        margin-left: 10px;
    }
    .input-text{
        margin-left: -105px;
    }
    .input-view1{
        margin-left: 0px;
    }
    @media only screen and (max-width: 1200px) {
    .mobile {
      width: 100%;
    }

    .form-select {
      width: 100%;
    }

    .form-select input {
      width: 60%;
    }

    .form-input {
        width: 100%;
    }

    .form-input input {
        margin-left: -30px;
    }

    .input-view1 {
      margin-left: -120px;
    }

    .input-view2 {
      margin-left: -50px;
    }
  }
  </style>



// WEBPACK FOOTER //
// UploadReceipt.vue?19f225ce